import { IEmployee } from '../../../services/employees.service';
import { IAccount, AgreementService, IAgreement, Masterdata } from "../../../services/index";
import * as _ from "lodash";
import * as moment from "moment";
interface IResolve {
    account: IAccount;
    agreements: IAgreement[];
    employees: IEmployee[];
    salaryScales: Masterdata[];
}

class AgreementsItemController {
    salaryScales: Masterdata[];

    private resolve: IResolve;
    private account: IAccount;
    private agreement: IAgreement;
    private employees: IEmployee[];
    private byEmployee: boolean;
    bySalaryScale: boolean;
    perCompany: boolean;

    constructor(
        private AgreementService: AgreementService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.account = this.resolve.account;
        this.employees = this.resolve.employees;
        this.salaryScales = this.resolve.salaryScales;

        this.perCompany = true;

        var agreementId : string = this.$stateParams['agreementId'];
        if (agreementId) {
            this.agreement = <IAgreement>_.find(<any>this.resolve.agreements, { "id": agreementId });
        } else {
            this.agreement = new IAgreement();
        }
        if (this.agreement.employeeId) {
            this.byEmployee = true;
            this.perCompany = false;
        }
        if (this.agreement.salaryScaleId) {
            this.bySalaryScale = true;
            this.perCompany = false;
        }
        if(this.agreement.ort) {
            this.perCompany = false;
        }
    }

    handleCheckboxChange = function(selected) {
        switch(selected) {
            case 'perCompany':
                this.byEmployee = false;
                this.bySalaryScale = false;
                this.agreement.ort = false;
                break;
            case 'byEmployee':
                this.bySalaryScale = false;
                this.agreement.ort = false;
                this.perCompany = false;
                break;
            case 'bySalaryScale':
                this.byEmployee = false;
                this.agreement.ort = false;
                this.perCompany = false;
                break;
            case 'ort':
                this.byEmployee = false;
                this.bySalaryScale = false;
                this.perCompany = false;
                break;
        }
    };

    startDateBeforeRender($dates) {
        // console.log('startDateBeforeRender');
        const todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0,0,0,0);
        // $dates.filter(function (date) {
        //     return date.utcDateValue < todaySinceMidnight.getTime();
        // }).forEach(function (date) {
        //     date.selectable = false;
        // });
    }

    endDateBeforeRender($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.agreement.dateTimeFrom) {
            var activeDate = moment(this.agreement.dateTimeFrom).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    public submitAgreement() {
        this.agreement.dateTimeFrom = moment(this.agreement.dateTimeFrom).format("YYYY-MM-DD HH:mm");
        this.agreement.dateTimeTo = moment(this.agreement.dateTimeTo).format("YYYY-MM-DD HH:mm");

        if(this.byEmployee){
            this.agreement.salaryScaleId = null;
            this.agreement.calculationIndex = null;
        } else if(this.bySalaryScale) {
            this.agreement.employeeId = null;
            this.agreement.grossHourlyWageValue = null;
            this.agreement.fee = null;
        } else if(this.agreement.ort) {
            this.agreement.salaryScaleId = null;
            this.agreement.employeeId = null;
            this.agreement.grossHourlyWageValue = null;
            this.agreement.fee = null;
        } else {
            this.agreement.salaryScaleId = null;
            this.agreement.employeeId = null;
            this.agreement.grossHourlyWageValue = null;
        }

        if (this.agreement.id === undefined) {
            this.agreement.accountId = this.account.id;
            this.AgreementService.post(this.agreement).then((data) => {
                this.closeModal();
            });
        } else {
            this.AgreementService.put(this.agreement.id, this.agreement).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {
        this.AgreementService.delete(this.agreement.id).then((data) => {
            this.closeModal();
        });
    }

    private closeModal() {
        this.$state.go('^', {tab: 4}, {reload: true});
    }
}

export const agreementsItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: AgreementsItemController,
    template: require('./agreements.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/agreements/agreements.item.component.ts